import React, { useState, useRef } from 'react';
import Calendar from './Calendar/index';
import MonthPicker from './MonthPicker';
import SpinningLoader from '../Utils/SpinningLoader';

// Include the following translation patterns in config/i18n.yml when using this component:
// - "*.common_text.*"
// - "*.feature.full_calendar.*"
// - "*.display_string.*"
// - "*.chronus_date_range_picker_strings.*"

// Include the following style files in the .html.erb where the react app is rendered
// <%= stylesheet_link_tag("full-calendar") %>
// <%= stylesheet_link_tag("full-calendar-month-view") %>

// props = {
//   loadingText: "",
//   eventsFetchUrl: "",
//   todayButtonTooltip: "",
//   eventRendererFn: () => {},
//   additionalEventsFetchParams: {}
//   handleEventClick: () => {}
// }

const MonthViewFullCalendar = props => {
  const calendarRef = useRef(null);
  const containerRef = useRef(null);
  const [showMonthPicker, setShowMonthPicker] = useState(false);

  return(
    <div className='border cui-border-radius-6'>
      <div className="pt-4 cui-full-calendar-pane-react cui-full-calendar-month-view cui-border-radius-6 bg-white" ref={ containerRef }>
        <SpinningLoader
          containerClass={ 'calendar-backdrop hide' }
          loadingText={ props.loadingText }
        />

        <Calendar
          calendarRef={ calendarRef }
          containerRef={ containerRef }
          setShowMonthPicker={ setShowMonthPicker }
          { ...props }
        />

        { showMonthPicker && <MonthPicker
            calendarRef={ calendarRef }
            setShowMonthPicker={ setShowMonthPicker }
          />
        }
      </div>
    </div>
  )
};

export default React.memo(MonthViewFullCalendar);